import styled from 'styled-components'

const OneLineTitleStyled = styled.div`
  background-color: transparent;
  font-size: 24px;
  line-height: 20px;

  .text {
    text-transform: uppercase;
    color: #4ef076;
  }
  .lending {
    color: #fab752;
  }

  .line {
    position: relative;
    top: -6px;
  }
`

export default OneLineTitleStyled
